/* customFeatureThunk.ts */

/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Interfaces */
import { CustomFeature } from "src/shared/constants/common/CustomFeature";

export const fetchCustomFeatures = createAsyncThunk<
  CustomFeature[] | undefined,
  void
>("fetchCustomFeatures", async () => {
  try {
    const response = await axiosInterceptor.get(
      "/options/custom_features"
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
});
